import { th } from 'style/theme';
import styled from 'styled-components';

export const StyledImg = styled.img`
  fill: ${th('colors.pickleBluewood')};
`;
